// Discover existing underlined text links, including links rendered later by
// route changes and AI answers. Leave card, icon and navigation designs intact.
export function initTextLinkHighlights(root = document.body) {
  const pending = new Set();
  let frame = 0;
  const collect = node => {
    if (node.nodeType !== 1) return;
    if (node.matches('a[href]')) pending.add(node);
    node.querySelectorAll('a[href]').forEach(link => pending.add(link));
  };
  const flush = () => {
    frame = 0;
    const links = [...pending];
    pending.clear();
    // Read before writing to avoid repeated style recalculation.
    const underlined = links.filter(link => link.isConnected
      && !link.closest('nav, .header, .margin-dock-left, .footer, .museum-header, .exhibition-header')
      && !link.classList.contains('site-text-link')
      && link.textContent.trim()
      && getComputedStyle(link).textDecorationLine.includes('underline'));
    underlined.forEach(link => link.classList.add('site-text-link'));
  };
  const schedule = () => { if (!frame && pending.size) frame = requestAnimationFrame(flush); };
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(collect);
      else if (record.target.matches('a[href]:not(.site-text-link)')) pending.add(record.target);
    });
    schedule();
  });
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  collect(root);
  schedule();
  return () => { observer.disconnect(); cancelAnimationFrame(frame); pending.clear(); };
}
